import React from "react";

interface SettingsManagedPanelProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

/**
 * The chrome around a settings panel that saves itself.
 *
 * `SettingsPanel` is for forms: it owns a dirty flag and a sticky Save/Discard
 * bar. Panels built on a table of records do not work that way — each row is
 * created, edited or deleted through its own dialog, and the change is already
 * committed by the time the dialog closes. A Save bar over the top of that
 * would be a control with nothing to save.
 *
 * So this is the same heading and the same rhythm, without the bar. Errors and
 * confirmations stay inside the embedded table, which is where the action was.
 */
export const SettingsManagedPanel: React.FC<SettingsManagedPanelProps> = ({
  title,
  description,
  children,
}) => (
  <div className="flex w-full grow shrink-0 basis-0 flex-col gap-8">
    <div className="flex flex-col gap-1">
      <span className="text-heading-2 font-heading-2 text-default-font">{title}</span>
      {description && (
        <span className="text-body font-body text-subtext-color">{description}</span>
      )}
    </div>

    <div className="flex w-full flex-col gap-8">{children}</div>
  </div>
);
